import type { EmployeeDesignation } from '../types';
import { hasOfficeOpsPrivileges } from './employeeDesignations';

/**
 * Admins, executive assistants, and office managers may open the Agent Activity page
 * (real-time agent API monitoring + monthly cost). Matches the Firestore
 * read rules on agentApiActivity / agentActivityStats / agentUsage*.
 */
export function canViewAgentActivity(args: {
  authRole: string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
}): boolean {
  if (args.authRole === 'admin') return true;
  return hasOfficeOpsPrivileges(args.designations);
}
